// Finance build (Workstream C — Amortization) — read hook for the loan
// Financials tab's amortization surface. Read-only: no mutations, so no
// invalidation is needed here.

import { useQuery } from "@tanstack/react-query";
import { amortizationApi } from "@/api/portfolioAdmin/amortizationApi";
import { amortizationKeys } from "./amortizationKeys";

export function useLoanAmortization(loanId: string | undefined) {
  return useQuery({
    queryKey: amortizationKeys.loan(loanId ?? ""),
    queryFn: () => amortizationApi.get(loanId!),
    enabled: !!loanId,
  });
}
